import { useContext, useMemo } from 'react'
import {
  buildPanelCheckItems,
} from 'components/Cruises/SearchPage/Filters/Inputs/CruiseExtraFiltersInputs'
import FilterPanelCheckboxGroup from 'components/Common/FilterPanel/FilterPanelCheckboxGroup'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'

import { trackEvent } from 'analytics/analytics'
import { mapCruiseLineFilterToSnowplowSearchEvent } from 'analytics/mapSnowplowSearchTracking'
import { searchEventWithContext } from 'analytics/snowplow/events'
import { type IntlShape, useIntl } from 'react-intl'

interface Props {
  cruiseTypes?: Set<string>
  onChange: (value: any) => void
  cruiseTypeFacets: Array<App.CruiseSearchFacetV2Item>
}

function getCruiseTypeLabel(intl: IntlShape, cruiseType: string): string {
  switch (cruiseType.toLowerCase()) {
    case 'ocean':
      return intl.formatMessage({
        id: 'OrBf-MAwgf0EKpApq4Gq',
        defaultMessage: 'Ocean',
        description: 'Cruise type filter option for ocean cruises in cruise search filters',
      })
    case 'river':
      return intl.formatMessage({
        id: '3orb5th_D1qt93ZO2-V0',
        defaultMessage: 'River',
        description: 'Cruise type filter option for river cruises in cruise search filters',
      })
    default:
      return cruiseType
  }
}

function CruiseCruiseTypeFilter({
  cruiseTypes,
  onChange,
  cruiseTypeFacets,
}: Props) {
  const intl = useIntl()
  const globalSearchState = useContext(GlobalSearchStateContext)

  const { cruiseTypeItems, hasCruiseTypes } = useMemo(() => {
    return {
      cruiseTypeItems: buildPanelCheckItems(cruiseTypeFacets.map(facet => ({
        ...facet,
        label: getCruiseTypeLabel(intl, facet.label),
      }))),
      hasCruiseTypes: cruiseTypeFacets.some(facet => facet.count > 0),
    }
  }, [cruiseTypeFacets, intl])

  if (!hasCruiseTypes) {
    return null
  }

  return <div data-testid="cruise-type-filter">
    <FilterPanelCheckboxGroup
      name="cruiseTypes"
      items={cruiseTypeItems}
      onChange={(e) => {
        trackEvent(searchEventWithContext({
          searchEvent: { type: 'filters' },
          sortContext: { value: 'recommended' },
          searchContext: mapCruiseLineFilterToSnowplowSearchEvent(globalSearchState),
          filterContexts: [{
            label: e.target.value,
            type: 'cruise_type',
            value: e.target.checked ? 'selected' : 'unselected',
          }],
        }))

        onChange(e)
      }}
      defaultSelected={cruiseTypes}
    />
  </div>
}

export default CruiseCruiseTypeFilter
